import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Table from 'components/table/Table';
import { Column } from 'devextreme-react/data-grid';
import styles from './AuthorizedList.module.css';

function AuthorizedList({
    tableList,
    tableConfig,
    optionChangedHandler,
    selectedId,
    rowsPerPage,
    onDoubleClick,
    classes,
    showSearchPanel,
    tableName,
}) {
    const tableRef = useRef();
    const renderAlertCell = (data) => {
        const spanStyle = {
            background: data.data?.authType?.color || data.data?.color || '#DCDCDC',
        };
        if (data.data?.authTypes?.length > 0) {
            return data.data?.authTypes.map((el) => {
                const spanStyle = {
                    background: el.color || '#DCDCDC',
                };
                return <span key={el.id} className={styles['dot-circle']} style={spanStyle}></span>;
            });
        } else {
            return <span className={styles['dot-circle']} style={spanStyle}></span>;
        }
    };

    const columns = tableConfig.map((field) => {
        switch (field.caption) {
            case 'Alerts':
                return <Column key={field.caption} {...field} cellRender={renderAlertCell} />;
            case 'Zoho ID':
                return <Column key={field.caption} {...field} cssClass={styles['max-width']} />;
            default:
                return <Column key={field.caption} {...field} />;
        }
    });

    return (
        <div className={styles['table-container']}>
            {tableList && (
                <Table
                    data={tableList}
                    columns={columns}
                    rowsPerPage={rowsPerPage ? rowsPerPage : 15}
                    optionChangedHandler={optionChangedHandler}
                    focusedRowKey={selectedId}
                    ref={tableRef}
                    onDoubleClick={onDoubleClick}
                    classes={classes}
                    showSearchPanel={showSearchPanel}
                    exportFileName={tableName}
                />
            )}
        </div>
    );
}

AuthorizedList.propTypes = {
    tableList: PropTypes.array,
    tableConfig: PropTypes.array.isRequired,
    optionChangedHandler: PropTypes.func.isRequired,
    selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rowsPerPage: PropTypes.number,
    onDoubleClick: PropTypes.func,
    classes: PropTypes.object,
    showSearchPanel: PropTypes.bool,
    tableName: PropTypes.string.isRequired,
};

export default AuthorizedList;
